export default __webpack_public_path__ + "static/media/C-charge Up.b9f34eb9.png";